export default "__VITE_ASSET__DceHcRZt__"